import { defineMessages } from '@jutro/locale';

export default defineMessages({
    policies: {
        id: 'ml.gateway.MLUnderlyingPoliciesListPopup.Policies',
        defaultMessage: 'Policies'
    },
    yourPolicies: {
        id: 'ml.gateway.MLUnderlyingPoliciesListPopup.Your policies',
        defaultMessage: 'Your policies'
    },
    foundPoliciesToBeIncluded: {
        id: 'ml.gateway.MLUnderlyingPoliciesListPopup.We found the policies below to be included under your umbrella coverage',
        defaultMessage: 'We found the policies below to be included under your umbrella coverage'
    },
    showPoliciesIncluded: {
        id: 'ml.gateway.MLUnderlyingPoliciesListPopup.We show the following policies included under your umbrella coverage',
        defaultMessage: 'We show the following policies included under your umbrella coverage'
    }
    
});
